export const PAYMENT_SETUP_PHONE_NUMBERS = ['+12153986999'];
